/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from './MergedCard.module.css';
import split from '../../../../assets/images/Fireboard/split.png';

const MergedCard = props => {
  const {
    active,
    flexBasis,
    minus,
    onClick,
    isEmployee,
    section,
    employee,
    revenueCentersMap,
    onRemove,
  } = props;

  //content of employee
  let firstName = '';
  let lastName = '';
  let posId = '';

  //content of section
  let sectionName = '';
  let revenueCenterName = '';

  if (isEmployee) {
    firstName = employee?.firstName;
    lastName = employee?.lastName;
    posId = employee?.posId;
  } else {
    const { name, revenueCenterId } = section || {};
    sectionName = name;
    if (revenueCenterId) {
      revenueCenterName = revenueCentersMap.has(revenueCenterId) ? revenueCentersMap.get(revenueCenterId) : '';
    }
  }

  const empStyles = { width: minus ? '70%' : '100%' };
  const sectionStyles = { width: minus ? '60%' : '100%' };

  return (
    <div className={classes.container} style={{ border: active ? '0.4vh solid #ad0028' : null, width: flexBasis }}>
      {isEmployee ? (
        <div className={classes.innerContainer} style={empStyles} onClick={onClick}>
          <span className={classNames({ [classes.centerAlignTxt]: true, [classes.employeeName]: true })}>{posId || ''}</span>
          <span className={classNames({ [classes.centerAlignTxt]: true, [classes.employeeName]: true })}>{lastName || ''},</span>
          <span className={classNames({ [classes.centerAlignTxt]: true, [classes.employeeName]: true })}>{firstName || ''} </span>
        </div>
      ) : (
        <div className={classes.innerContainer} style={sectionStyles} onClick={onClick}>
          <span className={classNames({ [classes.centerAlignTxt]: true, [classes.name]: true })}>{sectionName || ''}</span>
          {revenueCenterName && (
            <span className={classNames({ [classes.centerAlignTxt]: true, [classes.revCenterName]: true })}>({revenueCenterName})</span>
          )}
        </div>
      )}
      {minus && (
        <span
          className={classNames({ [classes.centerAlignTxt]: true, [classes.minus]: true })}
          onClick={onRemove}>
          <img src={split} alt='' className={classes.imgs} />
        </span>
      )}
    </div >
  );
};

export default MergedCard;

MergedCard.propTypes = {
  active: PropTypes.bool,
  flexBasis: PropTypes.any,
  minus: PropTypes.bool,
  onClick: PropTypes.func,
  isEmployee: PropTypes.bool,
  section: PropTypes.object,
  employee: PropTypes.object,
  revenueCentersMap: PropTypes.instanceOf(Map),
  onRemove: PropTypes.func,
};

MergedCard.defaultProps = {
  active: false,
  minus: false,
  onClick: () => { },
  isEmployee: false,
  section: {},
  employee: {},
  revenueCentersMap: new Map(),
  onRemove: () => { },
};
